import { Component, OnInit, Output, EventEmitter, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SolarService } from '../../../services/solarservice.service';
import { FormGroup, FormBuilder, NgForm, Validators } from '@angular/forms';
import { MessageError } from 'base-models';
import { MessagebarComponent } from 'basecomponents';


import { ActivatedRoute } from '@angular/router';
import { GlobalService } from '@solar/services/global.service';

import { EditionEnum } from 'base-models';
import { Site, Supervision, SupervisionStatusEnum, InfoSupervis, SupervisionError } from 'solar-bo';
import { ErrorcontrolService } from 'basecomponents';

@Component({
  selector: 'app-imagepanelchangeoffset',
  templateUrl: './imagepanelchangeoffset.component.html',
  styleUrls: ['./imagepanelchangeoffset.component.scss']
})
export class ImagePanelChangeOffsetComponent implements OnInit, OnChanges {

  alertmessage: MessageError;
  submitted: boolean;
  loadinglist: boolean = false;
  myform: FormGroup;
  titlesub: string = "Enter new panel offset ";
  title: string = "Edit OffSet for panels detected in image";
  dialogRef: MatDialogRef<any>;

  @Output() saveEvent = new EventEmitter<{ id_issue: string, id_panel: string }>();
  @Input() issue: SupervisionError;//null must be created by caller and set supervision id
  @Input() supervision: Supervision = new Supervision();
  editState: EditionEnum = EditionEnum.READ;
  @Input() ismodal: boolean = false;
  @ViewChild('frmsmessagebar') frmsmessagebar: MessagebarComponent;


  constructor(
    public solarService: SolarService
    , private fb: FormBuilder
    , public globservice: GlobalService
  ) {

    this.createForm();

  }

  ngOnInit() {
    console.log(this.issue);
    if (this.issue) {
      this.title = "Edit OffSet for panels detected in image " + this.issue.image.name;
    }
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  configureUI() {
    this.setForm();
  }

  isvalid() {
    let valid: boolean = false;
    const fm = this.myform.value;
    if (fm.offset_x == 0 && fm.offset_y == 0) {
      return false;
    }

    return this.myform.valid && !this.submitted;
  }

  createForm() {
    this.myform = this.fb.group({
      offset_x: [0, [Validators.required]],
      offset_y: [0, [Validators.required]],
    });
  }

  setForm() {
    if (!this.issue) {
      return;
    }
    this.myform.reset({
      offset_x: 0,
      offset_y: 0,
    });
  }


  saveModel(value?: any) {
    this.submitted = true;
    this.loadinglist = true;
    this.alertmessage = null;

    try {
      console.log("saveModel start", this.issue);
      const fm = this.myform.value;
      let change = { id_image: this.issue.image.id, id_supervision: this.supervision.id, offset_x: fm.offset_x, offset_y: fm.offset_y };
      this.solarService.supervisionImageChangePanelOffset(this.supervision.id, change)
        .subscribe(
          res => this.saveHandle(res)
          , err => this.handleError(err));

    } catch (error) {
      this.alertmessage = ErrorcontrolService.basichandleError("", error);
      this.submitted = false;
      this.loadinglist = false;
      console.log(error);
    }
  }

  saveHandle(res) {
    console.log(res);
    this.submitted = false;
    this.loadinglist = false;
    this.saveEvent.emit(res);
    if (this.dialogRef){
      this.dialogRef.close();
    }
    
  }

  savehandleError<T>(err: any) {
    this.handleError(err);
  }

  handleError<T>(err: any) {
    this.submitted = false;
    this.loadinglist = false;
    this.alertmessage = ErrorcontrolService.basichandleError("", err);
    console.error('An error occurred:', err.message);
  }


  public static openModalWithModel(dialog: MatDialog, issue: SupervisionError): MatDialogRef<ImagePanelChangeOffsetComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "700px";
    dialogConfig.data = { entity2edit: issue };

    let dialogRef: MatDialogRef<ImagePanelChangeOffsetComponent>;
    dialogRef = dialog.open(ImagePanelChangeOffsetComponent, dialogConfig);
    dialogRef.componentInstance.issue = issue;
    dialogRef.componentInstance.dialogRef = dialogRef;
    return dialogRef;
  }


}
